import React, {ReactNode, useContext, useEffect, useState} from "react";
import {Auth} from "./ridersUserContext";
import cookies from "js-cookie";

export const LanguageContext = React.createContext({});

export const LanguageContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [language, setLanguage] = useState<string>("EN");
  const { project, loading } = useContext<any>(Auth.context);

  useEffect(() => {
    const lang = cookies.get("accept-language");
    setLanguage(lang?.toUpperCase() || "EN");
  }, [project, loading]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageContextProvider.context = LanguageContext;
